import {
  findRule, isArrayOrObject, isEmpty, isNullOrUndefined,
} from '../Utils';

const validate = (vObj) => {
  const { errorBag } = vObj;
  const params = findRule(errorBag, 'required_if').ruleParams.split(',');
  const requiredValue = params[1];
  const { value } = vObj;
  const requiredField = params[0];
  // add a watcher here on vObj.vnode.context[requiredField]
  const requiredFieldVal = vObj.vnode.context[requiredField];
  const required = requiredValue.includes(String(requiredFieldVal).trim());
  
  const otherFieldLabel = vObj.vnode.context.$root.$validator.find((v) => v.compId.split('__')[0] === requiredField).fieldlabel;
  const rule = findRule(errorBag, 'required_if');

  rule.feedback = `${vObj.fieldlabel} is required if ${otherFieldLabel} 
                   has a value of ${requiredValue}`;

  if (!required) {
    return true;
  }
  if (isArrayOrObject(value)) {
    // console.log('required_if-is empty: ', isEmpty(value))    
    return !isEmpty(value);
  } if (isNullOrUndefined(value)) {
    return false;
  }
  return !!String(value).trim().length;
};

export { validate };

export default {
  validate,
};
